import { styled } from "@mui/material/styles";
import { Tab, Tabs } from "@mui/material";

export const BootstrappedTabs = styled(Tabs)(({ theme }) => ({
  "&.MuiTabs-root": {
    backgroundColor: "inherit",
    borderRadius: 10,
    minHeight: 0,
  },
  "& .MuiTabs-flexContainer": {
    display: "inline-flex",
    position: "relative",
    zIndex: 2,
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      width: "100%",
    },
  },

  "& .MuiTabs-indicator": {
    zIndex: "1",
    top: 0,
    bottom: 0,
    right: 0,
    height: "auto",
    background: "none",
    "&:after": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: "15px",
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        backgroundColor: "#FC4C4C",
      },
    },
  },
}));

export const BootstrappedTab = styled(Tab)(({ theme }) => ({
  "&.MuiTab-root": {
    marginRight: "1rem",
    border: "1px solid #FC4C4C",
    borderRadius: "15px",
    color: "#FC4C4C",
    textTransform: "none",
    padding: "8px 12px",
    minHeight: 0,
    transition: "0.4s all",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginBottom: "0.5rem",
      flex: "1",
      maxWidth: "none",
      marginRight: "0",
    },

    "&:hover": {
      background: "#FFF6F6",
    },
  },

  "&.Mui-selected": {
    color: "#fff",
    background: "#FC4C4C",

    "&:hover": {
      background: "#FC4C4C",
    },
  },
  wrapper: {
    color: "white",
    textTransform: "initial",
  },
}));
